import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar';
import Settings from './Settings';
import '../../components/Settings/Settings.css';

const SettingsHome = () => {
  // Initialize sidebar state from sessionStorage, default to false (expanded)
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const savedState = sessionStorage.getItem('isSidebarCollapsed');
    return savedState ? JSON.parse(savedState) : false;
  });

  // Update sessionStorage whenever isSidebarCollapsed changes
  useEffect(() => {
    sessionStorage.setItem('isSidebarCollapsed', JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  const handleSidebarToggle = () => {
    console.log('Sidebar toggle triggered, current state:', isSidebarCollapsed);
    setIsSidebarCollapsed((prev) => {
      const newState = !prev;
      console.log('New sidebar state:', newState);
      return newState;
    });
  };

  return (
    <div id="home1">
      <Sidebar
        onToggleSidebar={handleSidebarToggle}
        isCollapsed={isSidebarCollapsed}
      />
      <div id="home2" className={`settings-home-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <Settings />
      </div>
    </div>
  );
};

export default SettingsHome;